"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import _ from "lodash";
import API from "@ym-framework/api-utils";
import { Component, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
let PaymentNewTraffic = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.title = this.$t("paymentnewtraffic.title");
    this.loading = true;
    this.trafficDatas = new Array();
    this.paymentList = [];
    this.trafficSelected = {
      isLoading: false,
      traffic: null,
      payment: null,
      paymentAgreement: false,
      paymentCost: 0,
      paymentOriginalCost: 0,
      paymentOrderLoading: false,
      paymentGoldbeanUsed: 0,
      paymentGoldbeanCoins: 0,
      paymentGoldbeanLeft: 0,
      paymentGoldbeanLimit: 0
    };
    this.check_payment_tip = false;
  }
  mounted() {
    return __async(this, null, function* () {
      this.loading = true;
      yield this.getTraffics();
    });
  }
  getTraffics() {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        const response = yield API.get(
          `api://base.auth/api/v8/goods/traffic_package/purchase`
        );
        this.trafficDatas = response.data.datas;
        this.trafficSelected.traffic = this.trafficDatas[0];
        let arr = [];
        for (let payItem of (_a = this.trafficSelected.traffic) == null ? void 0 : _a.payments) {
          arr.push(payItem.payment);
        }
        this.trafficSelected.payment = (_b = this.trafficSelected.traffic) == null ? void 0 : _b.payments[0];
        this.paymentList = arr;
        yield this.calculateTraffic();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.loading = false;
      }
    });
  }
  changeTraffic() {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        let arr = [];
        for (let payItem of (_a = this.trafficSelected.traffic) == null ? void 0 : _a.payments) {
          arr.push(payItem.payment);
        }
        this.trafficSelected.payment = (_b = this.trafficSelected.traffic) == null ? void 0 : _b.payments[0];
        this.paymentList = arr;
        yield this.calculateTraffic();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  openWindow(url) {
    window.open(url, "_blank");
  }
  payForGoldbean() {
    return __async(this, null, function* () {
      if (this.trafficSelected.paymentGoldbeanLimit >= this.trafficSelected.paymentGoldbeanLeft) {
        this.trafficSelected.paymentGoldbeanUsed = this.trafficSelected.paymentGoldbeanLeft;
      } else {
        this.trafficSelected.paymentGoldbeanUsed = this.trafficSelected.paymentGoldbeanLimit;
      }
      yield this.calculateTraffic();
    });
  }
  calculateTraffic() {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        this.trafficSelected.isLoading = true;
        yield this.getGoldbean();
        const response = yield API.post(`api://base.auth.pro/v1/calculate`, {
          discounts: [],
          coin: this.trafficSelected.paymentGoldbeanUsed,
          quantity: 1,
          payType: (_a = this.trafficSelected.payment) == null ? void 0 : _a.payment,
          goodsSpecGuid: (_b = this.trafficSelected.traffic) == null ? void 0 : _b.id,
          type: "TRAFFIC_PACKAGE_NEW"
        });
        this.calculationTidy(response.data);
        this.trafficSelected.paymentCost = response.data.payPrice;
        this.trafficSelected.paymentOriginalCost = response.data.originalPrice;
      } catch (error) {
        console.log(error);
      } finally {
        this.trafficSelected.isLoading = false;
      }
    });
  }
  changePaymentType(paymentWay) {
    return __async(this, null, function* () {
      var _a;
      this.trafficSelected.payment = _.find((_a = this.trafficSelected.traffic) == null ? void 0 : _a.payments, { "payment": paymentWay });
      yield this.calculateTraffic();
    });
  }
  calculationTidy(_data) {
    return __async(this, null, function* () {
      this.trafficSelected.paymentGoldbeanLeft = this.trafficSelected.paymentGoldbeanCoins - _data.coin;
      this.trafficSelected.paymentGoldbeanLimit = Math.min(
        _data.maxCoin,
        this.trafficSelected.paymentGoldbeanCoins
      );
    });
  }
  //获取金豆余额
  getGoldbean() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v7/payment/account/coins`
        );
        this.trafficSelected.paymentGoldbeanCoins = response.data.account_coins.coins;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  show_tips() {
    this.check_payment_tip = true;
    setTimeout(() => {
      this.check_payment_tip = false;
    }, 2e3);
  }
  isShowCoin() {
    var _a;
    let paymentType = _.find(this.paymentList, { "payment": (_a = this.trafficSelected.payment) == null ? void 0 : _a.payment });
    if (paymentType !== void 0) {
      if (paymentType.useCoin === false) {
        this.trafficSelected.paymentGoldbeanUsed = 0;
      }
      return paymentType.useCoin;
    } else {
      return true;
    }
  }
  toCost() {
    let router = this.$router.resolve("/cost");
    window.open(router.href, "_blank");
  }
  paymentCreateTraffic() {
    return __async(this, null, function* () {
      var _a, _b;
      try {
        if (!this.trafficSelected.paymentAgreement) {
          this.show_tips();
          return;
        }
        this.trafficSelected.paymentOrderLoading = true;
        let discounts = [];
        if (this.trafficSelected.paymentGoldbeanUsed > 0) {
          discounts.push({
            type: "point",
            value: this.trafficSelected.paymentGoldbeanUsed
          });
        }
        const response = yield API.post(`api://base.auth/api/v8/orders/traffics/pay`, {
          "callback": "https://app.kuajingvs.com/paymentcomplete",
          "quantity": 1,
          "product": {
            "goods_spec_guid": (_a = this.trafficSelected.traffic) == null ? void 0 : _a.id
          },
          "pay_type": (_b = this.trafficSelected.payment) == null ? void 0 : _b.payment,
          "discounts": discounts
        });
        let payment = response.data;
        if (response.data.order) {
          payment.gift = response.data.order.pay_money <= 0;
        } else {
          payment.gift = false;
        }
        if (this.trafficSelected.payment.payment === "payssion.alipay" || this.trafficSelected.payment.payment === "payssion.wechat") {
          if (payment.model !== "payment.nomoney") {
            let newWindow = window.open("about:blank");
            newWindow.location.href = JSON.parse(payment.url).url;
          }
        }
        let _order_id = payment.order.id;
        let _qr_url = payment.url;
        let _gift = payment.gift;
        switch (this.trafficSelected.payment.payment) {
          case "alipay":
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "alipay",
                r: "",
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: "traffic"
              }
            });
            break;
          case "wxpay":
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "wechat",
                r: "",
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: "traffic"
              }
            });
            break;
          case "payssion.alipay":
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "payssion.alipay",
                r: "",
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: "traffic"
              }
            });
            break;
          case "payssion.wechat":
            this.$router.push({
              name: "PaymentConfirmation",
              query: {
                t: "payssion.wechat",
                r: "",
                id: _order_id,
                qr: _qr_url,
                gift: _gift,
                style: "traffic"
              }
            });
            break;
        }
        setTimeout(() => {
          this.trafficSelected.paymentOrderLoading = false;
        }, 1e3);
      } catch (error) {
        this.trafficSelected.paymentOrderLoading = false;
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  goBack() {
    this.$router.push("/cost_management#FlowDetail");
  }
  toConnectUs() {
    window.open("https://wpa1.qq.com/FzfSmq8R?_type=wpa&qidian=true", "_blank");
  }
  isReady(data) {
    this.loading = !data;
  }
};
PaymentNewTraffic = __decorateClass([
  Component({
    components: {},
    filters: {
      numFilter: (value) => {
        if (value === "-") {
          return value;
        }
        return Number(value).toFixed(2);
      }
    }
  })
], PaymentNewTraffic);
export {
  PaymentNewTraffic as default
};
